import { Row, TabsProps } from "antd";
import { useMemo } from "react";

export const useTabItems = (data: any, granularity: number) => {
  const tabItems: TabsProps["items"] = useMemo(
    () =>
      data
        ? Object.keys(data[granularity]).map(
            (key: string, i: number) => ({
              key: i.toString(),
              label: (
                <Row className="d-block">
                  <p className="mb-2 my-0">{data[granularity][key].label}</p>
                  <h3 className="h h3 w-500 stat">
                    {data[granularity][key].value}
                  </h3>
                </Row>
              ),
            }),
            [],
          )
        : [],
    [data, granularity],
  );

  return { tabItems };
};
